import { useMemo } from "react";

import { format, subMonths } from "date-fns";

import { getMonthRange, parseDay } from "@/utils/UDates";

/**
 * The bounds the view and project pages ask their figures for: this
 * month, and the previous one for the "vs last month" delta. Memoised
 * on the day so the query keys built from them stay stable within a
 * session.
 */
export const useMonthPeriods = (now: Date = new Date()) => {
	const day = format(now, "yyyy-MM-dd");

	return useMemo(() => {
		const today = parseDay(day);
		return {
			current: getMonthRange(today),
			previous: getMonthRange(subMonths(today, 1)),
		};
		// `day` is the string form of `now`: a new Date each render must not refresh this.
	}, [day]);
};
